var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2Br(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 596,
    viewBox: "0 0 298 596",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.635 413.397L93.5352 448.176L426.527 987.041L433.003 1620.46L553.103 1585.68L546.627 952.263L213.635 413.397Z",
    fill: "#D9166F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.755 71.9574L0.960938 124.891L512.711 962.061L527.5 1943.19L710.294 1890.25L695.505 909.128L183.755 71.9574Z",
    fill: "url(#paint0_radial_16648_125593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16648_125593",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(478.821 971.899) rotate(-16.1499) scale(193.47 1159.27)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2Br);
export default __webpack_public_path__ + "static/media/shape2BR.ec00587adbd42727ca9e025c5499e324.svg";
export { ForwardRef as ReactComponent };